class TestRideCarousel {
  constructor(root) {
    this.root = root;
    this.track = root.querySelector('[data-carousel-track]');
    this.cards = [...root.querySelectorAll('[data-carousel-card]')];
    this.dots = [...root.querySelectorAll('[data-carousel-dot]')];
    this.previousButton = root.querySelector('[data-carousel-prev]');
    this.nextButton = root.querySelector('[data-carousel-next]');
    this.autoplay = root.dataset.autoplay === 'true';
    this.timer = null;

    if (!this.track || this.cards.length < 2) return;

    this.previousButton?.addEventListener('click', () => this.move(-1));
    this.nextButton?.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.update(), { passive: true });
    this.track.addEventListener('scrollend', () => this.update(), { passive: true });
    ['pointerup', 'touchend'].forEach((eventName) => {
      this.track.addEventListener(eventName, () => window.requestAnimationFrame(() => this.update()), { passive: true });
    });
    window.addEventListener('resize', () => this.update(), { passive: true });

    this.update();

    if (this.autoplay && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ['mouseenter', 'focusin', 'touchstart'].forEach((eventName) => {
        root.addEventListener(eventName, () => this.stop(), { passive: true });
      });
      ['mouseleave', 'focusout', 'touchend'].forEach((eventName) => {
        root.addEventListener(eventName, () => this.start(), { passive: true });
      });
      this.start();
    }
  }

  index() {
    const left = this.track.scrollLeft;
    return this.cards.reduce((best, card, index) => {
      return Math.abs(card.offsetLeft - left) < Math.abs(this.cards[best].offsetLeft - left) ? index : best;
    }, 0);
  }

  move(direction) {
    const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
    const distance = this.cards[0].getBoundingClientRect().width + gap;
    const destination = Math.min(
      this.track.scrollWidth - this.track.clientWidth,
      Math.max(0, this.track.scrollLeft + (distance * direction))
    );

    this.track.scrollTo({ left: destination, behavior: 'smooth' });
  }

  update() {
    const active = this.index();
    const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    const atStart = this.track.scrollLeft <= 8;
    const atEnd = this.track.scrollLeft >= maximum - 8;

    this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === active));
    if (this.previousButton) {
      this.previousButton.disabled = atStart;
      this.previousButton.setAttribute('aria-disabled', String(atStart));
    }
    if (this.nextButton) {
      this.nextButton.disabled = atEnd;
      this.nextButton.setAttribute('aria-disabled', String(atEnd));
    }

    if (atEnd) this.stop();
  }

  start() {
    this.stop();
    this.timer = window.setInterval(() => this.move(1), 4000);
  }

  stop() {
    window.clearInterval(this.timer);
  }
}

document.querySelectorAll('[data-test-ride-carousel]').forEach((carousel) => new TestRideCarousel(carousel));

